export default {"src":"__ASTRO_ASSET_IMAGE__97SpWH9A__","width":265,"height":232,"format":"svg"}